<template>
    <div id="w-search">
        <div class="w-search-container">
            <div class="w-search-item">
                <input type="text" v-model="searchContent"  @keyup.enter="search"/>
                <button @click="search">搜索</button>
            </div>
            
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            searchContent:''
        }
    },
    methods:{
        search(){
            var data={
            searchContent: this.searchContent
            }
            this.$emit('search',data); 
        }
    }
}
</script>
<style scoped>
#w-search{
    width: 100%;
    height: 80px;
    margin-bottom: 20px;
}
.w-search-container{
    text-align: center;
}
.w-search-item{
    width: 600px;
    height: 80px;
    margin-left: calc(50% - 300px);
}
.w-search-item input{
    float: left;
    width: 500px;
    height: 40px;
    margin-top: 16px;
    font-size: 18px;
    color: rgba(0, 0, 0, 0.7);
}
.w-search-item button{
    float: left;
    width: 80px;
    height: 44px;
    margin-top: 16px;
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue